import { ApiTranslation } from '../../../core/api/entities/translation.entity';
import {
    BaseNestedFieldDefinition,
    FieldDefinitionTranslation
} from '../../../core/field-definitions/entities/field-definition.entity';
import { ExtendedBaseProfileField } from '../../../core/profiles/entities/extended-profile-field.entity';

export function ChildFieldToProfileField(
    childDefinition: BaseNestedFieldDefinition,
    profileField: ExtendedBaseProfileField,
    isBatch: boolean = false,
    indeterminate: boolean = false
): ExtendedBaseProfileField {
    return {
        FieldDefinitionId: childDefinition.FieldDefinitionId,
        DottedKey: childDefinition.DottedKey,
        FieldDefinition: childDefinition,
        DisplayLabel: childDefinition.Label,
        Labels: TranslationsToLangValue(childDefinition.Translations),
        Description: undefined,
        Descriptions: [],
        Public: profileField.Public,
        ReadOnly: profileField.ReadOnly || childDefinition.ReadOnly,
        Required: !isBatch && !indeterminate && (profileField.Required || childDefinition.Required)
    };
}

export function FieldDefinitionToProfileField(fieldDefinition: BaseNestedFieldDefinition): ExtendedBaseProfileField {
    return {
        FieldDefinitionId: fieldDefinition.FieldDefinitionId,
        DottedKey: fieldDefinition.DottedKey,
        FieldDefinition: fieldDefinition,
        DisplayLabel: fieldDefinition.Label,
        Labels: TranslationsToLangValue(fieldDefinition.Translations),
        Description: undefined,
        Descriptions: [],
        Public: true,
        ReadOnly: fieldDefinition.ReadOnly,
        Required: fieldDefinition.Required
    };
}

function TranslationsToLangValue(translations: FieldDefinitionTranslation): ApiTranslation[] {
    return Object.keys(translations).map(key => ({ Lang: key, Value: translations[key] }));
}
